module.exports = __webpack_public_path__ + "img/AncientMonument2.c8d89e60.png";